function normalizeRutInput (value) {
  return (value || '').toString().replace(/\./g, '').replace(/‐/g, '-').trim()
}

export function splitRut (value) {
  const normalized = normalizeRutInput(value)
  if (!normalized) {
    return { rut: '', dv: '' }
  }

  const compact = normalized.replace(/-/g, '')
  if (compact.length < 2) {
    return { rut: compact.replace(/\D/g, ''), dv: '' }
  }

  return {
    rut: compact.slice(0, -1).replace(/\D/g, ''),
    dv: compact.slice(-1).toLowerCase()
  }
}

export function formatRut (rut, dv = '') {
  const body = (rut || '').toString().replace(/\D/g, '')
  const verifier = (dv || '').toString().replace(/-/g, '').trim()

  if (!body) return ''
  const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return verifier ? `${formattedBody}-${verifier}` : formattedBody
}

export function computeRutDv (rut) {
  let value = parseInt((rut || '').toString().replace(/\D/g, ''), 10)
  if (!value) return ''

  let multiplierIndex = 0
  let sum = 1
  for (; value; value = Math.floor(value / 10)) {
    sum = (sum + value % 10 * (9 - multiplierIndex++ % 6)) % 11
  }

  return `${sum ? sum - 1 : 'k'}`
}

export function isValidRut (value) {
  const normalized = normalizeRutInput(value)
  if (!/^[0-9]+[-]{1}[0-9kK]{1}$/.test(normalized)) {
    return false
  }

  const { rut, dv } = splitRut(normalized)
  if (!rut || !dv) return false

  return computeRutDv(rut) === dv.toLowerCase()
}
